import React from "react";

function Virgo() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#AF8D4A"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.071,248.083,248.071
	c137.006,0,248.076-111.07,248.076-248.071C496.159,111.063,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#7C4C1D"
        d="M342.669,139.736c3.418-11.72,7-89.333-73.591-85.338c-18.652,0.925-28.766,8.482-32.454,20.284
	c-3.688,11.801-8.719,40.51-9.439,51.77c-0.85,13.285,1.71,32.496,1.71,32.496s26.141,118.062,35.388,125.577
	c7.868,6.394,20.162,14.261,41.305,12.786c12.85-0.896,24.286-9.628,29.872-22.375c11.802-26.921-5.9-64.169-2.582-81.871
	C335.461,179.289,337.506,157.439,342.669,139.736z"
      />
      <path
        fill="#DDB17C"
        d="M310.011,72.237c-13.267-22.3-45.235-16.854-45.235-16.854
	c-14.163,9.085-11.785,43.387-11.785,43.387c0.846,15.243,3.269,17.8,3.269,17.8c7.031,23.184,28.889,27.618,31.925,27.365
	c20.523-1.71,23.213-16.183,24.65-20.532c1.437-4.349,2.257-19.553,2.257-19.553C318.48,85.221,310.011,72.237,310.011,72.237z"
      />
      <path
        fill="#666666"
        d="M273.935,101.434c-4.457,0.141-7.944,4.225-7.944,4.225c0.028,0.917,3.737,3.857,8.195,3.718
	c4.456-0.141,7.943-4.226,7.943-4.226S278.392,101.294,273.935,101.434z"
      />
      <path
        fill="#F7F1ED"
        d="M273.97,102.534c-4.216,0.132-7.527,3.663-7.527,3.663c0.024,0.79,3.526,3.313,7.743,3.181
	c4.215-0.133,7.526-3.663,7.526-3.663S278.186,102.4,273.97,102.534z"
      />
      <circle fill="#5B5B5B" cx="274.08" cy="106.04" r="2.825" />
      <circle fill="#333333" cx="274.08" cy="106.04" r="1.999" />
      <path
        fill="#666666"
        d="M297.969,99.011c-4.395,0.751-7.286,5.278-7.286,5.278s4.232,3.306,8.627,2.555
	c4.395-0.753,7.44-4.375,7.287-5.28C306.598,101.563,302.364,98.257,297.969,99.011z"
      />
      <path
        fill="#F7F1ED"
        d="M298.155,100.094c-4.159,0.711-6.952,4.664-6.952,4.664s3.949,2.797,8.107,2.086
	c4.157-0.712,7.084-3.885,6.951-4.665C306.262,102.179,302.312,99.382,298.155,100.094z"
      />
      <circle fill="#5B5B5B" cx="298.73" cy="103.42" r="2.825" />
      <circle fill="#333333" cx="298.73" cy="103.42" r="1.999" />
      <polygon fill="#FFFFFF" points="288.822,127.206 279.608,128.193 288.853,129.929 298.079,126.969 " />
      <path
        fill="#CE8C78"
        d="M288.925,128.97c-3.08,0.204-9.667-0.686-9.667-0.686s3.656,5.716,9.941,5.299
	c6.286-0.416,9.106-6.563,9.106-6.563S292.004,128.767,288.925,128.97z"
      />
      <path
        fill="#DB9A83"
        d="M293.314,124.796c-2.31,0.153-4.582,0.918-4.582,0.918s-2.346-0.458-4.654-0.305
	c-2.31,0.152-4.821,2.875-4.821,2.875s6.021,0,9.612-0.239c3.593-0.238,9.436-1.024,9.436-1.024S295.623,124.643,293.314,124.796z"
      />
      <path fill="#E8B1A0" d="M280.67,127.89l5.752-1.597C282.463,124.774,280.67,127.89,280.67,127.89z" />
      <g>
        <path
          fill="#7C4C1D"
          d="M280.224,94.902c0,0-4.6-0.281-6.268-0.381c-1.666-0.099-4.431,0.021-6.715,0.622
		s-6.852,4.448-6.852,4.448s5.169-2.374,7.212-2.615c2.044-0.24,4.208-0.24,6.372,0c2.163,0.241,7.212,1.413,7.212,1.413
		L280.224,94.902z"
        />
        <path
          fill="#7C4C1D"
          d="M304.832,92.241c-2.353-0.198-5.096,0.159-6.721,0.543c-1.625,0.385-6.108,1.455-6.108,1.455
		l-0.347,3.6c0,0,4.771-2.023,6.861-2.634c2.09-0.609,4.222-0.981,6.276-1.097c2.054-0.114,7.555,1.333,7.555,1.333
		S307.186,92.439,304.832,92.241z"
        />
        <path
          fill="#7C4C1D"
          d="M201.699,177.333c-17.145,0-39.777-11.659-39.777-11.659c-30.176-16.46-56.236-6.172-56.236-6.172
		c-29.49,8.916-40.35,26.567-37.684,44.567s20.538,23.328,20.538,23.328c-5.486-12.344,5.487-21.946,5.487-21.946
		c21.26-17.831,44.578,0,44.578,0c13.03,8.23,33.604,27.433,33.604,27.433c27.433,21.26,59.666,4.115,59.666,4.115l6.857-66.523
		C222.959,180.076,201.699,177.333,201.699,177.333z"
        />
      </g>
      <path
        fill="#875327"
        d="M237.335,183.069c-20,3.5-39.667,11.667-81.333-11.333c-13.485-7.444-43.093-9.375-56-2
	c-38.5,22-18.667,44.333-18.667,44.333c1-20.5,29.208-37.996,51-28.333c51.5,22.833,59.333,35.667,92.333,31
	S237.335,183.069,237.335,183.069z"
      />
      <path
        fill="#7C4C1D"
        d="M251.699,215.386l-53.658,26.186c-7.316,17.375-21.946,25.146-21.946,25.146
	c-10.059,1.371-24.352-4.859-39.777-5.03c-20.575-0.228-21.031,17.832-21.031,17.832c0,10.514,13.259,10.973,13.259,10.973
	c-5.943-18.29,13.123-14.01,16.688-11.201c7.544,5.944,16.459,10.744,26.29,13.944c9.83,3.2,39.32-3.657,39.32-3.657
	c14.631-1.829,50.178-58.409,50.178-58.409L251.699,215.386z"
      />
      <g>
        <path
          fill="#DDB17C"
          d="M381.838,377.819c-34.364-70.078-122.988-66.296-122.988-66.296
		c21.488-25.604,24.46-80.011,24.46-80.011c10.058,4.573,17.809-2.92,19.546-6.172c8.916-16.687-11.43-37.947-11.43-37.947
		c-5.486-7.317,0.8-15.317,0.8-15.317c13.259-21.947-7.747-33.652-14.632-33.834c-31.018-0.818-33.877,12.439-41.288,34.102
		c-6.356,18.578-30.949,71.056-30.949,71.056c-15.545,20.118-43.306,74.033-45.824,81.444c-2.297,6.761,15.251,10.734,17.768,5.701
		c3.278-6.556,8.853-24.05,8.853-24.05l21.946-34.749c4.573-5.486,20.225-23.295,20.225-23.295
		c4.857-5.55,16.879-23.3,19.193-25.654c0.736-0.749-4.341,12.455-7.222,19.953c-8.979,23.374-24.894,42.187-24.894,42.187
		c-26.861,19.889-28.792,42.588-28.792,42.588c-1.829,24.689,20.574,39.32,20.574,39.32c-10.058,3.658-25.608,2.465-25.608,2.465
		c-9.145-3.658-18.813-6.841-27.365-2.28c-8.551,4.561-27.364,11.972-27.364,11.972c-21.033,7.315-25.084,22.804-22.992,28.992
		c2.092,6.189,19.203,2.743,19.203,2.743c7.316,0,78.639-17.375,78.639-17.375c32.919-4.571,124.361,4.572,124.361,4.572
		C390.984,403.422,381.838,377.819,381.838,377.819z"
        />
        <path
          fill="#DDB17C"
          d="M168.698,305.994l-1.446,4.439c-2.682,3.549-4.36,5.595-6.453,9.931
		c-2.126,4.407-4.486,12.163-4.486,12.163l3.28,2.376l6.539,3.799l9.165,3.216l6.297-16.006c0,0,0.683-8.007,0.754-9.536l2.363-5.66
		C179.785,307.723,174.254,306.154,168.698,305.994z"
        />
        <path
          fill="#DDB17C"
          d="M174.518,336.996c-1.272-0.452-2.95,0.324-3.456,1.747l-5.817,17.971
		c-0.46,1.292,0.104,2.673,1.257,3.084c1.157,0.412,2.465-0.304,2.925-1.594l6.479-17.811
		C176.414,338.97,175.794,337.45,174.518,336.996z"
        />
        <path
          fill="#DDB17C"
          d="M169.163,334.981c-1.317-0.491-3.019,0.161-3.547,1.576l-7.384,21.204
		c-0.478,1.284,0.101,2.688,1.293,3.131c1.194,0.446,2.552-0.235,3.03-1.519l8.237-20.991
		C171.32,336.966,170.479,335.472,169.163,334.981z"
        />
        <path
          fill="#DDB17C"
          d="M163.807,333.086c-1.26-0.488-3.024,0.118-3.571,1.527l-6.416,17.479
		c-0.544,1.409,0.034,2.947,1.294,3.434c1.26,0.487,2.725-0.257,3.269-1.666l6.889-17.297
		C165.818,335.153,165.066,333.573,163.807,333.086z"
        />
        <path
          fill="#DDB17C"
          d="M158.801,330.617c-1.178-0.477-1.984,0.722-2.55,2.123l-4.235,9.587
		c-0.491,1.215-0.06,2.535,0.962,2.949c1.023,0.412,2.25-0.238,2.741-1.454l4.466-9.716
		C160.75,332.705,159.979,331.092,158.801,330.617z"
        />
        <path
          fill="#DDB17C"
          d="M183.489,332.609c-0.805-2.691-2.236-8.138-2.236-8.138l-6.774,4.593l3.22,5.294
		c0,0-0.542,5.401,0.675,9.277c0.144,0.456,1.622,4.229,3.869,2.802c0.819-0.52,0.306-3.316,0.592-6.288
		C183.131,337.056,183.894,333.983,183.489,332.609z"
        />
      </g>
      <path
        fill="#EFE4DC"
        d="M182.745,342.002c0,0-2.134,2.711-0.678,4.848C182.067,346.851,183.32,347.034,182.745,342.002z"
      />
      <path
        fill="#E8C7AF"
        d="M154.309,342.148c-0.732-0.327-1.444-0.327-1.854,0.591c-0.03,0.065-0.185,0.347-0.209,0.419
	c-0.319,0.92,0.069,1.555,0.75,1.859c0.698,0.312,1.469,0.122,1.921-0.755c0.022-0.042,0.171-0.297,0.19-0.339
	C155.516,343.006,155.041,342.476,154.309,342.148z"
      />
      <path
        fill="#F7F3F0"
        d="M154.268,342.259c-0.709-0.303-1.393-0.293-1.774,0.595c-0.028,0.064-0.344,0.687-0.367,0.755
	c-0.292,0.889-0.338,1.88,0.542,2.257c0.881,0.378,1.622-0.386,2.045-1.235c0.02-0.041,0.331-0.637,0.348-0.679
	C155.441,343.066,154.976,342.563,154.268,342.259z"
      />
      <path
        fill="#EFE4DC"
        d="M154.219,342.245c-0.71-0.304-1.394-0.293-1.774,0.595c-0.028,0.064-0.14,0.34-0.163,0.409
	c-0.292,0.89,0.09,1.493,0.748,1.775c0.676,0.29,1.415,0.096,1.838-0.754c0.02-0.04,0.126-0.29,0.144-0.331
	C155.392,343.051,154.927,342.548,154.219,342.245z"
      />
      <path
        fill="#E8C7AF"
        d="M156.622,351.661c-0.904-0.372-1.771-0.345-2.235,0.788c-0.034,0.081-0.213,0.431-0.24,0.519
	c-0.354,1.131,0.144,1.89,0.98,2.235c0.862,0.354,1.794,0.094,2.313-0.989c0.025-0.053,0.197-0.368,0.219-0.42
	C158.124,352.661,157.525,352.032,156.622,351.661z"
      />
      <path
        fill="#F7F3F0"
        d="M156.576,351.797c-0.874-0.343-1.707-0.306-2.138,0.79c-0.031,0.079-0.393,0.849-0.418,0.933
	c-0.323,1.093-0.343,2.302,0.742,2.728c1.085,0.427,1.96-0.529,2.444-1.578c0.023-0.051,0.378-0.789,0.398-0.839
	C158.034,352.736,157.449,352.142,156.576,351.797z"
      />
      <path
        fill="#EFE4DC"
        d="M156.516,351.781c-0.875-0.344-1.708-0.306-2.138,0.789c-0.031,0.08-0.158,0.419-0.183,0.504
	c-0.323,1.092,0.165,1.815,0.975,2.133c0.834,0.329,1.727,0.065,2.209-0.984c0.023-0.051,0.144-0.359,0.162-0.409
	C157.973,352.72,157.389,352.124,156.516,351.781z"
      />
      <path
        fill="#E8C7AF"
        d="M160.956,356.976c-0.925-0.311-1.789-0.228-2.178,0.933c-0.028,0.084-0.184,0.445-0.205,0.535
	c-0.278,1.151,0.269,1.876,1.128,2.164c0.884,0.298,1.795-0.024,2.242-1.14c0.021-0.053,0.171-0.38,0.189-0.433
	C162.522,357.872,161.882,357.287,160.956,356.976z"
      />
      <path
        fill="#F7F3F0"
        d="M160.92,357.116c-0.896-0.285-1.723-0.193-2.081,0.93c-0.025,0.081-0.336,0.874-0.355,0.959
	c-0.251,1.111-0.189,2.318,0.922,2.671c1.111,0.354,1.92-0.659,2.332-1.738c0.02-0.052,0.326-0.811,0.342-0.862
	C162.438,357.954,161.814,357.399,160.92,357.116z"
      />
      <path
        fill="#EFE4DC"
        d="M160.858,357.102c-0.895-0.284-1.724-0.19-2.081,0.931c-0.025,0.081-0.128,0.429-0.148,0.515
	c-0.25,1.112,0.285,1.8,1.116,2.064c0.854,0.271,1.727-0.05,2.139-1.129c0.02-0.052,0.118-0.368,0.135-0.419
	C162.376,357.941,161.753,357.387,160.858,357.102z"
      />
      <path
        fill="#E8C7AF"
        d="M167.834,355.969c-0.926-0.311-1.789-0.228-2.178,0.934c-0.027,0.083-0.183,0.444-0.205,0.534
	c-0.278,1.151,0.268,1.876,1.127,2.164c0.884,0.296,1.797-0.025,2.242-1.14c0.021-0.056,0.171-0.381,0.189-0.435
	C169.4,356.864,168.762,356.279,167.834,355.969z"
      />
      <path
        fill="#F7F3F0"
        d="M167.798,356.107c-0.895-0.284-1.724-0.192-2.081,0.93c-0.026,0.081-0.337,0.874-0.355,0.96
	c-0.25,1.111-0.189,2.319,0.922,2.671c1.111,0.354,1.92-0.658,2.333-1.737c0.019-0.052,0.325-0.811,0.342-0.863
	C169.315,356.947,168.693,356.392,167.798,356.107z"
      />
      <path
        fill="#EFE4DC"
        d="M167.736,356.095c-0.895-0.284-1.723-0.191-2.08,0.93c-0.026,0.082-0.129,0.429-0.149,0.516
	c-0.25,1.111,0.285,1.8,1.115,2.063c0.854,0.272,1.727-0.05,2.139-1.13c0.021-0.051,0.119-0.367,0.135-0.417
	C169.254,356.934,168.631,356.38,167.736,356.095z"
      />
      <path
        fill="#C69661"
        d="M178.362,331.121c0,0-0.263,1.745-0.589,3.283c-0.328,1.549-1.441,4.883-1.441,4.883
	s1.493-3.539,1.803-4.785c0.313-1.259,0.659-3.427,0.659-3.427L178.362,331.121z"
      />
      <g>
        <path
          fill="#CCA172"
          d="M241.817,357.149c-10.262,5.701-34.632,9.697-34.632,9.697c17.831,4.915,38.995-7.106,45.264-9.602
		c30.795-12.257,81.913,5.226,81.913,5.226C303.272,341.439,261.262,346.347,241.817,357.149z"
        />
        <path
          fill="#CCA172"
          d="M242.848,235.17l11.408-22.415l14.653-28.792C259.536,187.393,246.048,226.94,242.848,235.17z"
        />
      </g>
      <path
        fill="#875327"
        d="M295.002,72.736l-12.667-12l-14.732-6.338c-24.341,3.688-36.879,35.404-22.005,95.886
	c4.142,16.839-3.688,51.262-22.127,70.808c0,0,43.356-38.015,41.625-62.43C262.531,122.461,243.335,79.403,295.002,72.736z"
      />
      <path
        fill="#9B6432"
        d="M265.889,54.647c14.991,4.283,28.78,15.756,38.113,29.756c17.798,26.697,4.732,69.838,0.111,78.42
	c-6.885,12.786-20.53,51.754-7.744,82.241c0,0,3.81,13.154-9.958,22.496c0,0-14.629,8.975-21.021,0.615
	c0,0,1.967,14.874,25.078,14.874c0,0,28.888-7.376,27.413-33.928c-1.191-21.442,3.368-50.583,8.36-71.793
	C358.002,42.403,265.889,54.647,265.889,54.647z"
      />
      <path
        fill="#E8C59E"
        d="M278.066,143.697c8.979,4.418,14.395,22.091,14.395,22.091
	C297.592,144.267,278.066,143.697,278.066,143.697z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
export default Virgo;
